import React from 'react'

import { PageTitle } from '@/layout-components'
import { ExampleWrapperSeamless } from '@/layout-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import MonthlyLimit from '@/housefolios-components/LaunchpadComponents/monthlyLimit'
import BonusProperties from '@/housefolios-components/LaunchpadComponents/bonusProperties'
import SaveMoney from '@/housefolios-components/Billing/SaveMoney'
import CancelPlanButton from '@/housefolios-components/TitleButtons/CancelPlanButton'
import { Alert, Button, Grid } from '@mui/material'
import withSession from '@/housefolios-components/Session/withSession'
import TransactionsTable from '@/housefolios-components/Billing/TransactionsTable'
import ContactSupport from '@/housefolios-components/Dialogs/ContactSupport'

function BillingSettingsPage(props) {
  const isRealeflow = Boolean(
    props.session?.me?.activeOrg?.isRealeflow,
  )
  const [supportOpen, setSupportOpen] = React.useState(false)

  return (
    <>
      <PageTitle
        titleHeading="Billing Settings"
        titleDescription="Make sure your information is up to date"
        icon={
          <FontAwesomeIcon
            style={{ fontSize: 30 }}
            icon={['far', 'file-lines']}

            sx={{ color: '#368cff' }}
          />
        }
      >
        <CancelPlanButton title />
      </PageTitle>
      <ExampleWrapperSeamless>
        {isRealeflow && (
          <Alert
            severity="info"

            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => setSupportOpen(true)}
              >
                Contact support
              </Button>
            }
            sx={{ mb: '1.5rem' }}
          >
            Realeflow billing questions can also be handled by
            support.
          </Alert>
        )}
        <ContactSupport
          open={supportOpen}
          handleClose={() => setSupportOpen(false)}
          affiliate={props.session?.me?.activeOrg?.member}
          dealsauceStripeCustomerID={
            props.session?.me?.activeOrg?.dealsauceStripeCustomerID
          }
          goHighLevelId={props.session?.me?.activeOrg?.goHighLevelId}
          session={props.session}
        />
        <Grid
          container
          direction="row"
          spacing={4}
          sx={{
            alignItems: 'stretch',
          }}
        >
          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
            sx={{ display: 'flex' }}
          >
            <MonthlyLimit page={'billing'} />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
            sx={{ display: 'flex' }}
          >
            <BonusProperties
              session={props.session}
              page={'billing'}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 4,
            }}
            sx={{ display: 'flex' }}
          >
            <SaveMoney />
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 12,
            }}
            sx={{ display: 'flex' }}
          >
            <TransactionsTable />
          </Grid>
        </Grid>
      </ExampleWrapperSeamless>
    </>
  )
}

export default withSession(BillingSettingsPage)
